import React from 'react';
import howitworks from '../Assets/howitworks.webp';
import generated from '../Assets/generated.webp';

const HowItWorks = () => {
  return (
    <section id="how-nostai-works" className="flex flex-col items-center gap-10 w-full max-w-[1257px] px-5 mt-10">
      {/* Description Section */}
      <div className="flex flex-col justify-center w-full max-w-[994px] px-5 mx-auto mt-8 mb-8">
        <h2 className="text-2xl tracking-wider leading-10 text-black text-center mb-4 max-md:text-lg" style={{ fontFamily: "Playfair Display" }}>
          What is NOSTAi?
        </h2>
        <p className="text-lg tracking-wide leading-8 text-black text-center max-md:text-base" style={{ fontFamily: "Playfair Display" }}>
          NOSTAi is an AI-powered design service that creates personalized memory quilt layouts using your favorite t-shirts and baby clothes. It transforms these cherished garments into beautifully arranged quilt designs, preserving your most precious memories in a heartfelt and artistic way.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-10 md:gap-20 items-start">
        {/* Left Column: Title and Image */}
        <div className="flex flex-col items-center">
          <h2
            className="text-xl md:text-2xl font-bold text-gray-700 mb-4 text-center md:text-left"
            style={{ fontFamily: "Playfair Display" }}
          >
            How It Works
          </h2>
          <img
            src={howitworks}
            alt="Choose Grid"
            className="w-[600px] h-[600px] md:w-[600px] md:h-[600px] lg:w-[600px] lg:h-[600px] object-contain"
          />
        </div>

        {/* Right Column: Second Image */}
        <div className="flex flex-col items-center justify-start">
          <div className="h-[40px] hidden md:block" />
          <img
            src={generated}
            alt="Generated Quilt Example"
            className="w-[600px] h-[600px] md:w-[600px] md:h-[600px] lg:w-[600px] lg:h-[600px] object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
